<template>
    <common-modal :width="'medium'" @emitEvent="emitEvent($event, ['close'])" @close="emitEvent({ name: 'close' })">
        <send-join-invites-collector
            v-if="showInviteOverview"
            :showImportContactsModal="showImportContactsModal"
            :headerText="headerText"
            :label="label"
            :placeholder="placeholder"
            :buttonLabel="buttonLabel"
            :initialNumOfFields="initialNumOfFields"
            :practiceType="practiceType"
            :inviteBy="inviteBy"
            :isInviteToPractice="isInviteToPractice"
            @join-invites-sent="joinInvitesSent"
            @check-emails-modal-show="checkEmailsShow"
            @close="closeJoinInvitesModal"
        ></send-join-invites-collector>
        <send-join-invites-overview
            v-if="showCheckInviteEmails"
            :emailsCheck="emailsCheck"
            :defaultCloseButtonEnabled="true"
            practiceType="physician"
            @new-email-invitations-present="invitesSentAfterEmailCheck"
            @close="closeJoinInvitesModal"
        ></send-join-invites-overview>
    </common-modal>
</template>

<script>
    import SendJoinInvitesCollector from 'components/page-elements/invites/SendJoinInvitesCollector'
    import SendJoinInvitesOverview from 'components/page-elements/invites/SendJoinInvitesOverview'
    import InviteByEnum from '@/enums/InviteByEnum'

    export default {
        components: {
            SendJoinInvitesCollector,
            SendJoinInvitesOverview,
        },
        props: {
            // join invite props
            showImportContactsModal: { type: Boolean, required: false, default: false },
            headerText: { type: String, required: true },
            label: { type: String, required: true },
            placeholder: { type: String, required: true },
            buttonLabel: { type: String, required: true },
            initialNumOfFields: { type: Number, default: 3 },
            inviteBy: { type: String, required: false, default: InviteByEnum.INVITE_BY_EMAIL },
            isInviteToPractice: { type: Boolean, dafault: false },

            // invite check props
            defaultCloseButtonEnabled: { type: Boolean, required: false, default: true },
            innerButtonsProperties: { type: Array, required: false, default: () => [] },

            // common props
            practiceType: { type: String, required: true },
        },

        data() {
            return {
                showInviteOverview: true,
                showCheckInviteEmails: false,
                invitePracticeType: '',
                emailsCheck: [],
            }
        },

        methods: {
            joinInvitesSent() {
                this.emitEvent({ name: 'join-invites-sent' })
            },

            checkEmailsShow(event) {
                this.emailsCheck = event.checkProperty
                this.invitePracticeType = event.practiceType
                this.showInviteOverview = false
                this.showCheckInviteEmails = true
            },

            invitesSentAfterEmailCheck(payload) {
                this.$emit('new-email-invitations-present', payload)
            },

            closeJoinInvitesModal() {
                this.emitEvent({ name: 'close' })
            },
        },
    }
</script>
